import type { FunctionComponent } from "react";
import PayoutRequetsAdminPartial from "../../../partials/admin/payouts/payout-requests.admin.partials";

export const PayoutRequestsAdminScreen: FunctionComponent = () => {
	return <PayoutRequetsAdminPartial />;
};
